import api from "./api";

export const taskService = {
  // Listar todas as tarefas
  getAll: async (params = {}) => {
    try {
      const response = await api.get("/tasks", { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar tarefas:", error);
      throw error;
    }
  },

  // Buscar uma tarefa específica
  getById: async (id) => {
    try {
      const response = await api.get(`/tasks/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar tarefa:", error);
      throw error;
    }
  },

  // SUBTAREFAS
  // Listar subtarefas de uma tarefa
  getSubtasks: async (taskId) => {
    try {
      const response = await api.get(`/tasks/${taskId}/subtasks`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar subtarefas:", error);
      throw error;
    }
  },

  // Criar subtarefa
  createSubtask: async (parentTaskId, subtaskData) => {
    try {
      const response = await api.post(`/tasks/${parentTaskId}/subtasks`, subtaskData);
      return response.data;
    } catch (error) {
      console.error("Erro ao criar subtarefa:", error);
      throw error;
    }
  },

  // Atualizar subtarefa
  updateSubtask: async (subtaskId, subtaskData) => {
    try {
      const response = await api.put(`/subtasks/${subtaskId}`, subtaskData);
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar subtarefa:", error);
      throw error;
    }
  },

  // Deletar subtarefa
  deleteSubtask: async (subtaskId) => {
    try {
      const response = await api.delete(`/subtasks/${subtaskId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar subtarefa:", error);
      throw error;
    }
  },

  // COMENTÁRIOS
  // Listar comentários de uma tarefa
  getComments: async (taskId) => {
    try {
      const response = await api.get(`/tasks/${taskId}/comments`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar comentários:", error);
      throw error;
    }
  },

  // Criar comentário
  createComment: async (taskId, content) => {
    try {
      const response = await api.post(`/tasks/${taskId}/comments`, { content });
      return response.data;
    } catch (error) {
      console.error("Erro ao criar comentário:", error);
      throw error;
    }
  },

  // Atualizar comentário
  updateComment: async (commentId, content) => {
    try {
      const response = await api.put(`/comments/${commentId}`, { content });
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar comentário:", error);
      throw error;
    }
  },

  // Deletar comentário
  deleteComment: async (commentId) => {
    try {
      const response = await api.delete(`/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar comentário:", error);
      throw error;
    }
  },

  // ANEXOS
  // Listar anexos de uma tarefa
  getAttachments: async (taskId) => {
    try {
      const response = await api.get(`/tasks/${taskId}/attachments`);
      console.log("[TASK SERVICE] Estrutura da resposta:", {
        attachments: response.data.attachments?.length || 0,
        count: response.data.count,
        isArray: Array.isArray(response.data),
        keys: Object.keys(response.data)
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload de anexo
  uploadAttachment: async (taskId, fileOrFormData) => {
    try {
      let formData;
      let fileName = 'unknown';
      let fileSize = 0;
      let fileType = 'unknown';
      
      // Verificar se é FormData ou File
      if (fileOrFormData instanceof FormData) {
        formData = fileOrFormData;
        // Tentar extrair info do arquivo do FormData
        const file = formData.get('file');
        if (file && file.name) {
          fileName = file.name;
          fileSize = file.size;
          fileType = file.type;
        }
      } else if (fileOrFormData instanceof File) {
        fileName = fileOrFormData.name;
        fileSize = fileOrFormData.size;
        fileType = fileOrFormData.type;
        
        formData = new FormData();
        formData.append('file', fileOrFormData);
      } else {
        throw new Error('Tipo de arquivo inválido. Esperado File ou FormData.');
      }
     
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      
      const response = await api.post(`/tasks/${taskId}/attachments`, formData, {
        headers: {
        }
      });
      
      return response.data;
    } catch (error) {
      console.error("[TASK SERVICE] Erro ao fazer upload:", error);
      console.error("[TASK SERVICE] Detalhes do erro:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      throw error;
    }
  },

  getAttachmentViewUrl: (attachmentId) => {
    const baseURL = process.env.REACT_APP_BACKEND_URL || '';
    const url = `${baseURL}/tasks/attachments/${attachmentId}/view`;
    console.log('[TASK SERVICE] Gerando URL de visualização:', {
      attachmentId,
      baseURL,
      finalUrl: url
    });
    return url;
  },

  // Gerar URL de download direto
  getAttachmentDownloadUrl: (attachmentId) => {
    const baseURL = process.env.REACT_APP_BACKEND_URL || '';
    const url = `${baseURL}/tasks/attachments/${attachmentId}/download`;
    console.log('[TASK SERVICE] Gerando URL de download:', {
      attachmentId,
      baseURL,
      finalUrl: url
    });
    return url;
  },

  // Download de anexo
  downloadAttachment: async (attachmentId, filename) => {
    try {
      console.log("[TASK SERVICE] Fazendo download do anexo:", attachmentId, filename);
      const response = await api.get(`/tasks/attachments/${attachmentId}/download`, {
        responseType: 'blob',
      });
      
      // Criar link de download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      console.log("[TASK SERVICE] Download realizado com sucesso");
      return response.data;
    } catch (error) {
      console.error("[TASK SERVICE] Erro ao fazer download:", error);
      throw error;
    }
  },

  // Deletar anexo
  deleteAttachment: async (attachmentId) => {
    try {
      console.log("[TASK SERVICE] Deletando anexo:", attachmentId);
      const response = await api.delete(`/tasks/attachments/${attachmentId}`);
      console.log("[TASK SERVICE] Anexo deletado com sucesso:", response.data);
      return response.data;
    } catch (error) {
      console.error("[TASK SERVICE] Detalhes do erro:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      throw error;
    }
  },

  // Criar nova tarefa
  create: async (taskData) => {
    try {
      const response = await api.post("/tasks", taskData);
      return response.data;
    } catch (error) {
      console.error("Erro ao criar tarefa:", error);
      throw error;
    }
  },

  // Atualizar tarefa
  update: async (id, taskData) => {
    try {
      const response = await api.put(`/tasks/${id}`, taskData);
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar tarefa:", error);
      throw error;
    }
  },

  // Deletar tarefa
  delete: async (id, options = {}) => {
    try {
      const response = await api.delete(`/tasks/${id}`, {
        data: {
          forceDelete: options.forceDelete || false,
          stopRecurrence: options.stopRecurrence || false,
          deleteFutureOccurrences: options.deleteFutureOccurrences || false,
          deleteEntireSeries: options.deleteEntireSeries || false,
          fromDate: options.fromDate || null
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar tarefa:", error);
      
      // Se for erro 409 (conflito de recorrência), retornar dados específicos
      if (error.response?.status === 409) {
        return {
          hasRecurrenceConflict: true,
          recurrenceInfo: error.response.data.recurrenceInfo
        };
      }
      
      throw error;
    }
  },

  bulkDelete: async (taskIds = [], options = {}) => {
    try {
      const response = await api.delete(`/tasks`, {
        data: {
          taskIds,
          forceDelete: options.forceDelete || false,
          stopRecurrence: options.stopRecurrence || false,
          deleteFutureOccurrences: options.deleteFutureOccurrences || false,
          deleteEntireSeries: options.deleteEntireSeries || false,
          fromDate: options.fromDate || null
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar tarefas em lote:", error);
      throw error;
    }
  },

  // Enviar notificações WhatsApp manualmente
  sendNotifications: async () => {
    try {
      const response = await api.post("/tasks/send-notifications");
      return response.data;
    } catch (error) {
      console.error("Erro ao enviar notificações:", error);
      throw error;
    }
  },

  // EXPORTAÇÃO
  // Exportar para PDF
  exportPDF: async (filters = {}) => {
    try {
      const params = new URLSearchParams(filters).toString();
      const response = await api.get(`/tasks/export/pdf?${params}`, {
        responseType: 'blob',
      });
      
      // Criar link para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tarefas_${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return response.data;
    } catch (error) {
      console.error("Erro ao exportar PDF:", error);
      throw error;
    }
  },

  // Exportar para Excel
  exportExcel: async (filters = {}) => {
    try {
      const params = new URLSearchParams(filters).toString();
      const response = await api.get(`/tasks/export/excel?${params}`, {
        responseType: 'blob',
      });
      
      // Criar link para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tarefas_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return response.data;
    } catch (error) {
      console.error("Erro ao exportar Excel:", error);
      throw error;
    }
  },

  // RESPONSÁVEIS (ASSIGNEES)
  getAssignees: async (taskId) => {
    try {
      const response = await api.get(`/tasks/${taskId}/assignees`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar responsáveis:", error);
      throw error;
    }
  },

  addAssignee: async (taskId, userId) => {
    try {
      const response = await api.post(`/tasks/${taskId}/assignees`, { userId });
      return response.data;
    } catch (error) {
      console.error("Erro ao adicionar responsável:", error);
      throw error;
    }
  },

  removeAssignee: async (taskId, userId) => {
    try {
      const response = await api.delete(`/tasks/${taskId}/assignees/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao remover responsável:", error);
      throw error;
    }
  }
};

export default taskService;
